import { ColDef } from "ag-grid-community";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { frequencySortingFn } from "@/components/pages/automations/off-hours/grid/sorting-functions/frequencySortingFn";

export const offHoursFrequencyComparator: ColDef<OffHoursSchedule>["comparator"] =
  (valueA, valueB, nodeA, nodeB) => {
    const current = nodeA?.data?.start_cron;
    const next = nodeB?.data?.start_cron;

    return frequencySortingFn(current ?? null, next ?? null);
  };
